import { Button, Grid, TextField } from '@mui/material'
import { useCallback, useState } from 'react'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as TooltipChat,
  Legend,
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  TooltipChat,
  Legend,
)

const RelatorioFluxoDeCaixa = () => {
  const [dataInicial, setDataInicial] = useState('')
  const [dataFinal, setDataFinal] = useState('')
  const [loading, setLoading] = useState(false)

  const emiteRelatorio = useCallback(() => {
    setLoading(true)

    metodoPrograma('geraRelatorio', {
      dataInicial,
      dataFinal,
    })
      .then((res) => {
        if (res.status) {
          const base64 = res.arquivo.replace(
            /^data:application\/pdf;base64,/,
            '',
          )

          const byteCharacters = atob(base64)
          const byteNumbers = new Array(byteCharacters.length)

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNumbers)

          const blob = new Blob([byteArray], {
            type: 'application/pdf',
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')

          link.href = url
          link.download = 'relatorio_fluxo_caixa.pdf'
          document.body.appendChild(link)
          link.click()

          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      .finally(() => setLoading(false))
  }, [dataInicial, dataFinal])

  return (
    <Programa codigo="CtrlRelatorioFluxoPlanoDeConta">
      <Grid container spacing={2} style={{ marginTop: 50 }}>
        <Grid item xs={12} md={3}></Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Data Inicial"
            type="date"
            margin="dense"
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={dataInicial}
            onChange={(e) => setDataInicial(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            label="Data Final"
            type="date"
            margin="dense"
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={dataFinal}
            onChange={(e) => setDataFinal(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}></Grid>
        <Grid item xs={12} md={3}></Grid>

        <Grid item xs={6} style={{ marginTop: 50 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={emiteRelatorio}
            disabled={loading}
          >
            {loading ? 'Gerando...' : 'Emitir Relatório'}
          </Button>
        </Grid>
      </Grid>
    </Programa>
  )
}

export default RelatorioFluxoDeCaixa
